import React from 'react';
import Chart from 'react-apexcharts';
import { useTheme } from '@mui/material/styles';
import { Stack, Typography, Avatar, Box } from '@mui/material';
import { IconArrowUpRight } from '@tabler/icons';
import DashboardCard from '../../shared/DashboardCard';

const EmptyState = () => (
  <Box
    sx={{
      p: 2,
      textAlign: 'center',
      border: '1px dashed',
      borderColor: 'divider',
      borderRadius: 1,
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}
  >
    <Typography variant="body2" color="text.secondary">
      No booking data available
    </Typography>
  </Box>
);

const NewBookingsGraph = ({ monthlyBookings }) => {
  const theme = useTheme();
  const secondary = theme.palette.secondary.main;
  const secondarylight = theme.palette.secondary.light;
  const successlight = theme.palette.success.light;

  if (!monthlyBookings?.length) {
    return (
      <DashboardCard>
        <Typography variant="h6" color="textSecondary">New Bookings</Typography>
        <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mt: 0.5 }}>
          This month
        </Typography>
        <EmptyState />
      </DashboardCard>
    );
  }

  const categories = monthlyBookings.map(item => item.month);
  const dataValues = monthlyBookings.map(item => Number(item.bookings));

  const options = {
    chart: { type: 'area', height: 80, sparkline: { enabled: true } },
    stroke: { curve: 'smooth', width: 2 },
    fill: { colors: [secondary], type: 'solid', opacity: 0.05 },
    tooltip: { theme: theme.palette.mode },
  };
  const series = [{ name: 'Bookings', data: dataValues }];

  return (
    <DashboardCard 
    // footer={<Chart options={options} series={series} type="area" height="30px" />}
    >
      <>
        <Typography variant="h6" color="textSecondary">New Bookings</Typography>
        <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mt: 0.5 }}>
          This month
        </Typography>
        <Stack direction="row" spacing={1} mt={1} alignItems="center">
          <Typography variant="h4">
            {monthlyBookings[monthlyBookings.length - 1]?.bookings || 0}
          </Typography>
          <Avatar sx={{ bgcolor: successlight, width: 24, height: 24 }}>
            <IconArrowUpRight width={18} color="#39B69A" />
          </Avatar>
          {/* <Typography variant="subtitle2" fontWeight="600">+9%</Typography> */}
        </Stack>
      </>
    </DashboardCard>
  );
};

export default NewBookingsGraph;